import { WhatsAppButtonIcon } from "./WhatsAppButtonIcon";
import { WhatsappButtonCounter } from "./WhatsappButtonCounter";
import { WhatsAppButtonType } from "./typings";
import { whatsappTheme } from "./constants";

export const WhatsAppButton = ({
  setOpenSignal,
  isLoading = false,
  style,
  onPointerDown
}: WhatsAppButtonType) => {
  return (
    <div
      onClick={setOpenSignal}
      onPointerDown={onPointerDown}
      style={{ ...whatsappTheme.buttonContainer, ...style }}
      aria-label="Abrir WhatsApp"
    >
      <WhatsAppButtonIcon />
      <WhatsappButtonCounter isLoading={isLoading} />
    </div>
  );
};
